import React from 'react';
import { useTranslation } from 'react-i18next';

const Header: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <h4 className="mb-1">{t("forgotPassword.pageTexts.header.title")}</h4>
      <p className="mb-5">{t("forgotPassword.pageTexts.header.subTitle")}</p>
    </>
  )
};

export default Header;